import {classNames, observer, React} from '@api'
import {Menu} from '@blueprintjs/core'
import {Popover2} from '@api'
import {TabNode, TabSetNode} from '@flexlayout'
import {NewFlexTabMenuItems, useStores} from '@modules'
import {globalStores} from '@stores'
import * as css from './FlexLayoutCustomTab.css'
import {PrimaryIconButton} from 'centric-ui-components'

export const NewFlexTabButton = observer<{ tabSet: TabSetNode }>(function NewFlexTabButton({tabSet}) {
  const {flexLayout: {create: {onNewOrUpdateTabFromWorkspaceItem}}} = useStores()
  return (
    <Popover2
      interactionKind='hover'
      position='bottom-left'
      minimal
      content={<Menu>
        <NewFlexTabMenuItems tabSet={tabSet}/>
      </Menu>}
    >
      <div>
      <PrimaryIconButton
        icon='plus'
        tooltip='New Tab'
        tooltipPosition='right'
        onClick={(e) => onNewOrUpdateTabFromWorkspaceItem(e, {tabSet})}
        wrapperClassName={classNames(css.tabsetButton, css.newTabButton)}
        //onClick={() => flexLayout.create.newCatalogTab('card', tabSet, true)}
      />
      </div>
    </Popover2>
  )
})

export const HideTabsetToggleButton = observer<{ tabSet: TabSetNode }>(function HideTabsetToggleButton({tabSet}) {
  return (
    tabSet && <PrimaryIconButton
		wrapperClassName={classNames(css.tabsetButton, css.hideTabset)}
		tooltip='Show Tab(s)'
		active={tabSet.enableTabStrip !== false}
		tooltipPosition='bottom'
		icon='new-grid-item'
		onClick={() => {
          tabSet.enableTabStrip = tabSet.enableTabStrip !== true
        }}
	/>
  )
})

export const MaximizeTabSetButton = observer<{ tabSet: TabSetNode }>(function MaximizeTabSetButton({tabSet}) {
  const {flexLayout} = globalStores

  return (
    <PrimaryIconButton
      tooltip='Maximize Tab' tooltipPosition='bottom'
      wrapperClassName={classNames(css.tabsetButton, css.maximizeTabSet)}
      icon='maximize'
      onClick={() => flexLayout.toggleMaximize(tabSet.selectedNode as TabNode)}
    />
  )
})

export const DeleteTabSetButton = observer<{ tabSet: TabSetNode }>(function DeleteTabSetButton({tabSet}) {
  return (
    <PrimaryIconButton
      tooltip='Delete Tabs' tooltipPosition='bottom'
      wrapperClassName={classNames(css.tabsetButton, css.deleteTabSet)}
      icon='trash'
      onClick={() => {
        tabSet.removeFromParent()
      }}
    />
  )
})


// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/flexLayout-widgets/FlexLayoutCustomTabSet.tsx